export default class RecaptchaUtils {
  /**
   * Metodo para realizar la comprobación de recaptcha para la acción pasado por parámetro
   */
  static checkRecaptcha (actionChecking) {
    const self = this;
    return new Promise((resolve, reject) => {
      self.$recaptchaLoaded().then(value => {
        // Execute reCAPTCHA for action 'action'
        self.$recaptcha(actionChecking).then(token => {
          const data = {token: token};
          // Check reCAPTCHA on google verification site executed in BE
          self.$http.put('recaptcha/check/', data).then(response => {
            const success = response.data['success'];
            const scoreValid = response.data['score_valid'];
            const actionResponse = response.data['action'];

            const result = success && scoreValid && actionChecking === actionResponse;
            resolve(result);
          }, response => {
            console.log(response);
            reject(response);
          });
        }, reason => {
          console.log(reason);
          reject(reason);
        });
      }, reason => {
        console.log(reason);
        reject(reason);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/utils/recaptcha.utils.js